export default async function getAccessToken(url, clientId, clientSecret){
    if (!clientId || !clientSecret) {
        return ("Client ID and Client Secret are required.");
    }

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
    };
    const body = new URLSearchParams({
        grant_type: "client_credentials",
        client_id: clientId,
        client_secret: clientSecret,
    });

    try {
        const response = await fetch(url, {
            method: "POST",
            headers,
            body,
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        const authToken = {
            token: data.access_token,
            statusCode: response.status,
        }

        return authToken;
    } catch (err) {
        console.log("Error fetching access token:", err);
    }
}